import { trpc } from '@/shared/api';

/** 결제 준비(payments.prepare) — payments 에 READY 행을 만들고 토스 주문번호를 받는다. */
export const usePreparePayment = () => trpc.payments.prepare.useMutation();
